module.exports = {
  'align': {
    ''        : require('..//icons/align-left.svg'),
    'center'  : require('..//icons/align-center.svg'),
    'right'   : require('..//icons/align-right.svg'),
    'justify' : require('..//icons/align-justify.svg')
  },
  'background': require('..//icons/background.svg'),
  'blockquote': require('..//icons/blockquote.svg'),
  'bold'      : require('..//icons/bold.svg'),
  'clean'     : require('..//icons/clean.svg'),
  'code'      : require('..//icons/code.svg'),
  'code-block': require('..//icons/code.svg'),
  'color'     : require('..//icons/color.svg'),
  'direction' : {
    ''        : require('..//icons/direction-ltr.svg'),
    'rtl'     : require('..//icons/direction-rtl.svg')
  },
  'float': {
    'center'  : require('..//icons/float-center.svg'),
    'full'    : require('..//icons/float-full.svg'),
    'left'    : require('..//icons/float-left.svg'),
    'right'   : require('..//icons/float-right.svg')
  },
  'formula'   : require('..//icons/formula.svg'),
  'header': {
    '1'       : require('..//icons/header.svg'),
    '2'       : require('..//icons/header-2.svg')
  },
  'italic'    : require('..//icons/italic.svg'),
  'image'     : require('..//icons/image.svg'),
  'indent': {
    '+1'      : require('..//icons/indent.svg'),
    '-1'      : require('..//icons/outdent.svg')
  },
  'link'      : require('..//icons/link.svg'),
  'list': {
    'ordered' : require('..//icons/list-ordered.svg'),
    'bullet'  : require('..//icons/list-bullet.svg'),
    'check'   : require('..//icons/list-check.svg')
  },
  'script': {
    'sub'     : require('..//icons/subscript.svg'),
    'super'   : require('..//icons/superscript.svg'),
  },
  'strike'    : require('..//icons/strike.svg'),
  'underline' : require('..//icons/underline.svg'),
  'video'     : require('..//icons/video.svg')
};



// WEBPACK FOOTER //
// ./ui/icons.js